import React, { useState, useCallback } from "react";
import DownloadsSummary from "./DownloadsSummary";
import DownloadsFilter from "./DownloadsFilter";
import DownloadsTable from "./DownloadsTable";

const DownloadsReport = () => {
	const [filters, setFilters] = useState({
		startDate: "",
		endDate: "",
		search: "",
	});

	// Use a callback to update filters to avoid unnecessary re-renders
	const handleApplyFilters = useCallback((newFilters) => {
		setFilters(newFilters);
	}, []);

	return (
		<div className="p-6">
			<DownloadsSummary />
			<DownloadsFilter onApply={handleApplyFilters} />
			<DownloadsTable filters={filters} />
		</div>
	);
};

export default DownloadsReport;
